import React, { createContext, lazy, useContext, useEffect, useState } from 'react';

import './LoanDetails.scss';
import { formatterCurrency } from '@common/utils/formatters/formatter';
import { BoxValues } from './components/BoxValues/BoxValues';
import { Button } from 'antd';
import { TaskOpenModalContext } from 'scenes/Private/Private';
import warningIcon from 'assets/images/warning-icon.svg';
import { useGetTaskResponsesByTask } from 'services/task/querys';
import { TasksContext } from '../../Dashboard';
import { BoxClosing } from './components/BoxClosing/BoxClosing';
import { BoxPartners } from './components/BoxPartners/BoxParteners';
import { BoxLoanDetails } from './components/BoxLoanDetails/BoxLoanDetails';
import { BoxPropertyDetails } from './components/BoxProperty/BoxProperty';
import { BoxBudget } from './components/BoxBudget/BoxBudget';
import { BoxFees } from './components/BoxFees/BoxFees';
import { BoxAdditionalDocuments } from './components/BoxAdditionalDocuments/BoxAdditionalDocuments';
import { BoxLoanDocuments } from './components/BoxLoanDocuments/BoxLoanDocuments';

interface ILoanDetailsProps {
  loanSelected: any;
  onClose: () => void;
}

const LoanDetails: React.FC<ILoanDetailsProps> = ({ loanSelected, onClose }) => {
  const tasks: any = useContext(TasksContext);

  const taskAddDocs = tasks.find((item: any) => item.key === 'add-docs');
  const { data: anotherDocs, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: {
      findResponsesByTask: { taskId: taskAddDocs?._id }
    },
    pause: true
  });
  const { setHandler: setTaskOpenModal }: any = useContext(TaskOpenModalContext);

  useEffect(() => {
    if (tasks.length > 0)
      getTaskResponses({ requestPolicy: 'network-only' });
  }, [tasks])

  if (!loanSelected)
    return <>Loading...</>;

  return (
    <div className='loan-details'>
      <div className='loan-details-top-bar'>
        <div className='loan-info'>
          <span className='loan-address'>LOAN DETAILS</span>
        </div>
        <div className='close-button-container' onClick={onClose}>
          CLOSE X
        </div>
      </div>

      <div className='loan-details-first-row'>
        <div className='loan-progress'>
          <div className='loan-address'>
            {loanSelected.name}
          </div>
        </div>
        {loanSelected.salesforceData?.loanNumber && (
          <span className="loan-number">Loan number: #{loanSelected.salesforceData?.loanNumber}</span>
        )}
      </div>

      <div className='loan-details-box-change-terms'>
        <img src={warningIcon} alt="icon" />
        <span>
          These terms are subject to change based on information you submit throughout the loan process. Well reach out if there any changes.
        </span>
      </div>

      <div className='loan-details-main'>
        <div className='left-column'>
          <div className='loan-summary'>
            <BoxClosing loanSelected={loanSelected} />
            <BoxPartners loanSelected={loanSelected} setTaskOpenModal={setTaskOpenModal} tasks={tasks} />
          </div>
          <BoxValues
            rate={loanSelected?.loanData?.selectedOption?.rate}
            loanTerm={loanSelected?.loanData?.selectedOption?.loanTerm}
            monthlyPayment={formatterCurrency(loanSelected?.loanData?.selectedOption?.monthlyPayment)}
            totalLoanAmount={formatterCurrency(loanSelected?.loanData?.selectedOption?.totalLoanAmount)}
            ltv={loanSelected?.loanData?.selectedOption?.ltv}
          />
          <BoxLoanDetails loanSelected={loanSelected} />
          <BoxPropertyDetails loanSelected={loanSelected} />
          <BoxBudget loanSelected={loanSelected} />
          <BoxFees loanSelected={loanSelected} />
          {/* <div className='content-box'>
            <div className='label'>
              Notes
            </div>
            <div className='content'>
              <ReactQuill
                value={loanSelected?.salesforceData?.notes || ''}
                readOnly={true}
                theme={'bubble'}
                style={{
                  height: 420,
                  display: loanSelected?.salesforceData?.notes ? 'block' : 'none'
                }}
              />
            </div>
          </div> */}
        </div>
        <div className='right-column'>
          <BoxLoanDocuments loanSelected={loanSelected} />
          <BoxAdditionalDocuments loanSelected={loanSelected} anotherDocs={anotherDocs} tasks={tasks} />
        </div>
      </div>
    </div>
  );
};

export const LoanDetailsModal = (props: any) => {
  const { openSectionRight: visible, closeModal } = props;

  return (
    <div className="cont-modal">
      {/* {props.renderButtonTrigger(props.handlerSetVisibile)} */}
      {props.visible && (
        <div className="ModalTask">
          <Button
            className="button-close-mask"
            style={{ width: visible ? '5%' : '20%' }}
            onClick={closeModal}
          />
          <div
            className={`ModalTask-content animate__animated animate__fadeInRight`}
            style={{ width: visible ? '60%' : '80%', overflow: 'auto' }}
          >
            {props.children}
          </div>
        </div>
      )}
    </div>
  );
}

export default LoanDetails;